import Home from "./pages/home.js";
import Project from "./pages/project.js";
import Article from "./pages/article.js";
import Sidebar from "./components/sidebar";
import "./index.css";
import "animate.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App w-full h-full md:h-[100vh] font-poppins bg-cream sm:overflow-auto md:overflow-hidden m-0 p-0">
      <BrowserRouter>
        <Sidebar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/article" element={<Article />} />
          <Route exact path="/project" element={<Project />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
